export default __webpack_public_path__ + "static/media/crowther_low_resolution.d492a1ac.mp4";